import Button from '@admin/components/button'
import Icon from '@admin/components/icon'
import T from '@admin/components/t'
import PropTypes from 'prop-types'
import React from 'react'

const strings = {
  blocked: {
    title: 't(Desktop Notifications Blocked)',
    text: 't(You\'ve disallowed desktop notifications on this device. If you want to enable them in the future, you\'ll need to open your browser\'s preferences to change that.)'
  },
  send: 't(Send desktop notifications)'
}

class Desktop extends React.Component {

  static contextTypes = {
    admin: PropTypes.object,
    device: PropTypes.object,
    host: PropTypes.object,
    notifications: PropTypes.object
  }

  static propTypes = {
    defaultValue: PropTypes.bool,
    onChange: PropTypes.func,
    onReady: PropTypes.func
  }

  state = {
    permission: null,
    ready: false,
    value: true
  }

  _handleDemo = this._handleDemo.bind(this)
  _handleRequestPermission = this._handleRequestPermission.bind(this)
  _handleToggle = this._handleToggle.bind(this)

  render() {
    const { permission, ready, value } = this.state
    if(!ready) return null
    return (
      <div className="maha-desktop">
        { permission === 'default' &&
          <div className="maha-preferences">
            <div className="maha-preference">
              <div className="maha-preference-icon">
                <Icon icon="bell" />
              </div>
              <div className="maha-preference-label">
                <Button { ...this._getEnable() } />
              </div>
            </div>
          </div>
        }
        { permission === 'denied' &&
          <div className="maha-desktop-panel denied">
            <div className="maha-desktop-panel-label">
              <strong><T text={ strings.blocked.title } /></strong><br />
              <T text={ strings.blocked.text } />
            </div>
          </div>
        }
        { permission === 'granted' &&
          <div className="maha-preferences">
            <div className="maha-preference" onClick={ this._handleToggle }>
              <div className="maha-preference-icon">
                { value ?
                  <Icon icon="check-circle" /> :
                  <Icon icon="circle-o" />
                }
              </div>
              <div className="maha-preference-label">
                <T text={ strings.send } /> ( <Button { ...this._getDemo() } /> )
              </div>
            </div>
          </div>
        }
      </div>
    )
  }

  componentDidMount() {
    const { host } = this.context
    const { defaultValue } = this.props
    const value = defaultValue === true
    host.notifications.getPermission().then(permission => {
      this.setState({
        permission,
        ready: true,
        value
      })
      this.props.onReady()
    })
  }

  componentDidUpdate(prevProps, prevState) {
    const { value } = this.state
    if(value !== prevState.value) {
      this.props.onChange(value)
    }
  }

  _getDemo() {
    return {
      label: 't(demo)',
      className: 'link',
      handler: this._handleDemo
    }
  }

  _getEnable() {
    return {
      label: 't(Enable desktop notifications)',
      className: 'link',
      handler: this._handleRequestPermission
    }
  }

  _handleDemo(e) {
    e.stopPropagation()
    const { team } = this.context.admin
    this.context.notifications.pushDesktop({
      team,
      title: team.title,
      body: 'This is an desktop notification'
    })
  }

  async _handleGetToken() {
    const { device, host } = this.context
    const token = await host.notifications.getToken()
    device.saveToken(token)
  }

  async  _handleRequestPermission() {
    const { host } = this.context
    const permission = await host.notifications.requestPermission()
    this.setState({ permission })
    if(permission === 'denied') return
    await this._handleGetToken()
  }

  _handleToggle() {
    const { value } = this.state
    this.setState({
      value: !value
    })
  }

}

export default Desktop
